import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelySocgenMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="socgenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#E60028", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#000000", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#2C2C2C", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#socgenGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = -360 + i * 45;
            const y = -360 + j * 45;
            const isRed = (i + j) % 2 === 0;
            return (
              <rect
                key={`square-${i}-${j}`}
                x={x}
                y={y}
                width={45}
                height={45}
                fill="none"
                stroke={isRed ? "#E60028" : "#FFFFFF"}
                strokeWidth={1.5}
                opacity={0.2}
              />
            );
          })
        )}
        {Array.from({ length: 14 }).map((_, r) => (
          <circle
            key={`trust-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 28}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 3 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.015}
          />
        ))}
        <rect x={-55} y={-55} width={110} height={110} fill="none" stroke="#E60028" strokeWidth={4} opacity={0.6} />
        <rect x={-35} y={-35} width={70} height={70} fill="#000000" opacity={0.5} />
      </g>
    </svg>
  );
}
